export default {
    /**
     * Fetch all recipes from the API.
     *
     * @param {object} context
     * @param {object} payload
     * @param {boolean} payload.includeCategories
     * @param {string[]} payload.categories
     * @param {string} payload.locale
     *
     * @returns {Promise<object>}
     */
    async fetchRecipes(context, {
        includeCategories = true,
        categories,
        locale,
    } = {}) {
        const filters = {
            publishedAt: {
                not: {
                    null: true,
                },
            },
            page: {
                documentId: {
                    not: null,
                },
            },
        };

        if (categories?.length) {
            filters.and = categories.map((category) => ({
                recipe_categories: {
                    slug: {
                        eq: category,
                    },
                },
            }));
        }

        const { default: query } = await import('../../queries/recipes.graphql');

        return this.$strapi.query(query, {
            includeCategories,
            filters,
            locale,
        });
    },
};
